import styled from "styled-components";

export const ContainerInstrucoes = styled.p`
  font-size: 0.9rem;
  color: ${({ theme }) => theme.colors.neutral.neutral70};
  margin-bottom: 1rem;
`;

export const ContainerForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 1.25rem;
  padding: 20px;
  background-color: ${({ theme }) => theme.colors.neutral.neutral05};
  border-radius: 8px;
`;
